<template>
  <div :class="{ 'op--modal-container': true, hide: !show }" @click="close">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="datetimepicker" @click.stop>
          <div class="datetimepicker-tab" v-show="leg !== 'leg2' && !charter.enabled && !mtech.enabled">
            <span :class="{'active':isFutureActive}" @click="isFutureActive = true">
              <i class="far fa-calendar-alt"></i>{{ $t('serviceSelect.future') }}
            </span>
            <span :class="{'active':!isFutureActive}" @click="isFutureActive = false">
              <i class="fas fa-bolt"></i>{{ $t('serviceSelect.rightNow') }}
            </span>
          </div>
          <div class="datetimepicker-box" v-show="!isFutureActive">
            <span>{{ $t('serviceSelect.selectAsap') }}</span>
            <span v-if="extraStop.leg1.length">{{ $t('serviceSelect.dateAsapLyft') }}</span>
            <a class="op-btn btn-lg btn-success btn-block margin-t-m" @click="setASAP">{{ $t('serviceSelect.pickAsap') }}</a>
          </div>
          <div class="datetimepicker-box" v-show="isFutureActive">
            <div class="row">
              <div class="column medium-6 small-12">
                <div class="title">
                  <span v-if="charter.enabled && charter.datePicker === 'startDate'">{{ $t('serviceSelect.selectStartDate') }}</span>
                  <span v-else-if="charter.enabled && charter.datePicker === 'endDate'">{{ $t('serviceSelect.selectEndDate') }}</span>
                  <span v-else-if="dateTimePickerData.forPickupDate || (charter.enabled && charter.datePicker === 'startDate')">{{ $t('serviceSelect.selectPickupDate') }}</span>
                  <span v-else-if="isAirportPickup">{{ $t('serviceSelect.flightArrival') }}</span>
                  <span v-else-if="isAirportDropoff">{{ $t('serviceSelect.flightDeparture') }}</span>
                  <span v-else>{{ $t('serviceSelect.selectPickupDate') }}</span>
                </div>
                <datepicker :inline="true" v-on:input="changeDate"
                  v-model="pickupDate" :disabled="disabledDate">
                </datepicker>
              </div>
              <div class="column medium-6 small-12">
                <div class="pickuptime">
                  <div class="title">
                    <span v-if="charter.enabled && charter.datePicker === 'startDate'">{{ $t('serviceSelect.selectStartTime') }}</span>
                    <span v-else-if="charter.enabled && charter.datePicker === 'endDate'">{{ $t('serviceSelect.selectEndTime') }}</span>
                    <span v-else-if="dateTimePickerData.forPickupDate || (charter.enabled && charter.datePicker === 'startDate')">{{ $t('serviceSelect.selectPickupTime') }}</span>
                    <span v-else-if="isAirportPickup">{{ $t('serviceSelect.arrivalTime') }}</span>
                    <span v-else-if="isAirportDropoff">{{ $t('serviceSelect.departureTime') }}</span>
                    <span v-else>{{ $t('serviceSelect.selectPickupTime') }}</span>
                  </div>
                  <!-- <span class="pickuptime-rule" v-if="(!isAirportPickup && !isAirportDropoff && !charter.enabled) || (charter.enabled && charter.datePicker === 'startDate')">{{ $t('serviceSelect.mustBe', {pickuptimeRule: pickuptimeRule}) }}</span> -->
                  <div class="pickuptime-ui">
                    <span class="select">
                      <i :class="['fas fa-chevron-up increase fa-2x', hourClass.up]" @mousedown="hourClass.up = 'highlight'"
                        @mouseup="hourClass.up = ''" @click="adjustHour('up')"></i>
                      <div class="label">
                        <span>{{ pickupTime.hour }}</span>
                      </div>
                      <i :class="['fas fa-chevron-down decrease fa-2x', hourClass.down]"  @mousedown="hourClass.down = 'highlight'"
                        @mouseup="hourClass.down = ''" @click="adjustHour('down')"></i>
                    </span>
                    <span>:</span>
                    <span class="select">
                      <i :class="['fas fa-chevron-up increase fa-2x', minuteClass.up]" @mousedown="minuteClass.up = 'highlight'"
                        @mouseup="minuteClass.up = ''" @click="adjustMinute('up')"></i>
                      <div class="label">
                        <span>{{ pickupTime.minute }}</span>
                      </div>
                      <i :class="['fas fa-chevron-down decrease fa-2x', minuteClass.down]" @mousedown="minuteClass.down = 'highlight'"
                        @mouseup="minuteClass.down = ''" @click="adjustMinute('down')"></i>
                    </span>
                    <span class="select" v-if="!isMilitaryTime">
                      <i :class="['fas fa-chevron-up increase fa-2x', ampmClass.up]" @mousedown="ampmClass.up = 'highlight'"
                        @mouseup="ampmClass.up = ''" @click="adjustAmPm('up')"></i>
                      <div class="label">
                        <span>{{ pickupTime.ampm }}</span>
                      </div>
                      <i :class="['fas fa-chevron-down decrease fa-2x', ampmClass.down]" @mousedown="ampmClass.down = 'highlight'"
                        @mouseup="ampmClass.down = ''" @click="adjustAmPm('down')"></i>
                    </span>
                  </div>
                  <div class="buttons">
                    <span class="date-error-msg margin-t-s margin-b-s" v-show="!!timeBufferError">{{ timeBufferError }}</span>
                    <span class="op-btn btn-lg btn-success btn-block margin-t-s" @click="setPickupDate(false)">{{ $t('serviceSelect.apply') }}</span>
                    <span class="op-btn btn-lg btn-danger btn-block margin-t-s" @click="setSuggestedTime" v-if="dateTimePickerData.forPickupDate">
                      {{ $t('serviceSelect.useSuggested') }}<br/>
                      <small>{{ dateTimePickerData.suggestedTime }}</small>
                    </span>
                    <div class="cancel-pickup margin-t-s">
                      <span @click="close">{{ $t('common.cancel') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import Datepicker from 'vuejs-datepicker'
import ApiQuote from '@/modules/api/quote'
import featureToggle from '@/modules/api/featureToggle'
import { isValidNumber } from 'libphonenumber-js'
import ApiPickupType from '@/modules/api/pickup-type'

export default {
  name: 'datetime-picker',
  props: ['leg'],
  components: { Datepicker },
  data () {
    return {
      pickupDate: moment.tz(this.$store.state.reservation.leg1.timezone)
        .add(this.$store.state.reservation.webTimeBuffer, 'minutes').format('MM/DD/YYYY'),
      pickupTime: {
        hour: moment.tz(this.$store.state.reservation.leg1.timezone).add(this.$store.state.reservation.webTimeBuffer, 'minutes').format('hh'),
        minute: moment.tz(this.$store.state.reservation.leg1.timezone)
          .add(this.$store.state.reservation.webTimeBuffer, 'minutes')
          .add(5 - (moment.tz(this.$store.state.reservation.leg1.timezone).add(this.$store.state.reservation.webTimeBuffer, 'minutes').minute() % 5), 'minutes').format('mm'),
        ampm: moment.tz(this.$store.state.reservation.leg1.timezone).add(this.$store.state.reservation.webTimeBuffer, 'minutes').format('A')
      },
      today: moment.tz(this.$store.state.reservation.leg1.timezone),
      timeBufferError: '',
      isFutureActive: true,
      defaultTimeout: '',
      maxHour: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      hourFormat: 'hh',
      hourClass: { up: '', down: '' },
      minuteClass: { up: '', down: '' },
      ampmClass: { up: '', down: '' }
    }
  },
  computed: {
    isAirportPickup () { return this.$store.state.reservation[this.leg].isAirportPickup },
    isAirportDropoff () { return this.$store.state.reservation[this.leg].isAirportDropoff },
    webTimeBuffer () { return this.$store.state.reservation.webTimeBuffer },
    dateTimePickerData () { return this.$store.state.serviceSelection.dateTimePicker },
    show () { return this.dateTimePickerData.show },
    calendar () { return this.dateTimePickerData.calendar },
    _pickupDate () {
      return this.$store.state.reservation[this.leg].pickupDate
    },
    disabledDate () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
    _isAsap () { return this.$store.state.reservation[this.leg].isAsap },
    pickuptimeRule () {
      let webTimeBuffer = parseInt(this.$store.state.reservation.webTimeBuffer)
      if (webTimeBuffer < 60) { return webTimeBuffer + ' minute(s) ' }

      let hours = parseInt(webTimeBuffer / 60)
      let minutes = (hours * 60) - webTimeBuffer
      if (minutes > 0) { return hours + ' hour(s) ' + minutes + ' minute(s) ' }
      return hours + ' hour(s)'
    },
    estimatedDropoff () {
      let currentTime = moment(this.pickupTime.hour + ':' + this.pickupTime.minute + '' + this.pickupTime.ampm, 'hh:mmA')
      if (this.isMilitaryTime) {
        currentTime = moment(this.pickupTime.hour + ':' + this.pickupTime.minute, 'HH:mm')
      }
      return currentTime.add(this.$store.state.reservation[this.leg].eta, 'seconds').format(featureToggle.timeFormat(this, false))
    },
    isMilitaryTime () {
      if (this.$store.state.reservation.charter.MilitaryTimeWidget) {
        this.hourFormat = 'HH'
        this.maxHour = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
      }
      return this.$store.state.reservation.charter.MilitaryTimeWidget
    },
    arrivalDepartureLabel () { return this.$settings.get('ArrivalDepartureLabel') === '1' },
    _forPickupDate () { return this.$store.state.serviceSelection.dateTimePicker.forPickupDate },
    extraStop () { return this.$store.state.reservation.extraStop },
    charter () { return this.$store.state.reservation.charter },
    mtech () { return this.$store.state.reservation.mtech },
    isUSLocations () {
      let rsvp = this.$store.state.reservation.leg1
      return ['US', 'USA'].indexOf(rsvp.pickup.country) > -1 && ['US', 'USA'].indexOf(rsvp.dropoff.country) > -1
    }
  },
  methods: {
    close () {
      this.timeBufferError = ''
      this.$store.commit('serviceSelection/hideDateTimePicker')
      this.$store.commit('serviceSelection/setForPickupDate', false)

      let self = this
      let rsvp = self.$store.state.reservation
      let hourFormat = this.isMilitaryTime ? 'HH' : 'hh'
      if ((!rsvp[self.leg].pickupDate && !rsvp[self.leg].isAirportPickup && !rsvp[self.leg].isAirportDropoff) ||
        (!rsvp[self.leg].flightDate && (rsvp[self.leg].isAirportPickup || rsvp[self.leg].isAirportDropoff))
      ) {
        let timebuffer = rsvp[self.leg].isAirportPickup || rsvp[self.leg].isAirportDropoff ? 0 : rsvp.webTimeBuffer
        self.defaultTimeout = setInterval(function () {
          self.pickupDate = moment.tz(rsvp.leg1.timezone)
            .add(timebuffer, 'minutes').format('MM/DD/YYYY')
          self.pickupTime = {
            hour: moment.tz(rsvp.leg1.timezone).add(timebuffer, 'minutes').format(hourFormat),
            minute: moment.tz(rsvp.leg1.timezone)
              .add(timebuffer, 'minutes')
              .add(5 - (moment.tz(rsvp.leg1.timezone).add(timebuffer, 'minutes').minute() % 5), 'minutes').format('mm'),
            ampm: moment.tz(rsvp.leg1.timezone).add(timebuffer, 'minutes').format('A')
          }
        }, 10000)
      }
    },
    leadingZero (x) {
      x = x + ''
      return x.length === 1 ? '0' + x : x
    },
    changeDate (val) {
      this.pickupDate = moment(val).format('MM/DD/YYYY')
      if (this.defaultTimeout) { clearInterval(this.defaultTimeout) }
    },
    setPickupDate (applySuggested = false) {
      let self = this
      let selectedDate = self.pickupDate + ' ' + self.pickupTime.hour + ':' +
        self.pickupTime.minute + '' + self.pickupTime.ampm
      if (self.isMilitaryTime) {
        selectedDate = self.pickupDate + ' ' + self.pickupTime.hour + ':' +
          self.pickupTime.minute
      }
      let webTimeBuffer = self.isAirportPickup || self.isAirportDropoff ? 0 : this.$store.state.reservation.webTimeBuffer
      if (self.dateTimePickerData.forPickupDate) {
        webTimeBuffer = this.$store.state.reservation.webTimeBuffer
      }

      self.timeBufferError = ''
      let rsvpLeg = this.$store.state.reservation[this.leg]
      let timezone = rsvpLeg.timezone
      if (moment.tz(selectedDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false), timezone).format('X') < moment().tz(timezone).add(webTimeBuffer, 'minutes').format('X')) {
        // self.timeBufferError = self.$t('serviceSelect.timeBufferError1', {webTimeBuffer: webTimeBuffer})
        if (self.charter.enabled) { return }
        if ((self.isAirportPickup || self.isAirportDropoff) && !self.dateTimePickerData.forPickupDate) {
          let direction = self.isAirportPickup ? 'arrival' : 'departure'
          self.timeBufferError = self.$t('serviceSelect.timeBufferError2', {direction: direction})
          return
        }
      }

      if (self.charter.enabled) {
        let _date = {}
        if (self.charter.datePicker !== 'flightDate') {
          let startDate = moment(self.charter.datePicker === 'startDate' ? selectedDate : self.charter.startDate, 'MM/DD/YYYY hh:mmA')
          let endDate = moment(self.charter.datePicker === 'endDate' ? selectedDate : self.charter.endDate, 'MM/DD/YYYY hh:mmA')
          if (self.charter.datePicker === 'startDate') {
            self.$store.commit('reservation/setCharterData', {endDate: ''})
          }
          if (self.charter.datePicker === 'endDate') {
            if (startDate && endDate && startDate.diff(endDate, 'minutes') > 0) {
              self.timeBufferError = self.$t('common.endDateMust')
              return
            }
            if (startDate && endDate && endDate.diff(startDate, 'minutes') > self.charter.maxDuration) {
              let time = moment.duration(self.charter.maxDuration, 'minutes').humanize({h: Infinity})
              self.timeBufferError = self.$t('common.maxDurationCharter', {time: time})
              return
            }
            if (startDate && endDate && startDate.format('MM/DD/YYYY hh:mmA') === endDate.format('MM/DD/YYYY hh:mmA')) {
              self.timeBufferError = self.$t('common.invalidDateRange')
              return
            }
          }
          _date[self.charter.datePicker] = selectedDate
          self.$store.commit('reservation/setCharterData', _date)
          if (CONFIG.Env == 'production' && window.gtag) { // eslint-disable-line
            gtag('event', `Charter ${self.charter.datePicker}`, { // eslint-disable-line
              value: selectedDate
            })
          }
        } else {
          if (CONFIG.Env == 'production' && window.gtag) { // eslint-disable-line
            gtag('event', `Charter Flight Date`, { // eslint-disable-line
              value: selectedDate
            })
          }
          self.$store.commit('reservation/setFlightDate', { leg: 'leg1', value: selectedDate })
          self.$store.commit('reservation/setShowFlightModal', true)
          self.$store.commit('reservation/setCustomPickupTime', { leg: 'leg1', value: false })
        }
        self.$store.commit('serviceSelection/hideDateTimePicker')
        return
      }

      if (self._isAsap) {
        self.$store.state.reservation['leg1'].selectedService = ''
        self.$store.state.reservation['leg2'].selectedService = ''
      }
      self.$store.commit('reservation/setIsAsap', { leg: self.leg, value: false })

      self.$store.commit('reservation/setQuoteLoading', true)
      if ((self.isAirportPickup || self.isAirportDropoff) && !self.dateTimePickerData.forPickupDate) {
        self.$store.commit('reservation/setFlightDate', { leg: self.leg, value: selectedDate })
        self.$store.commit('reservation/setShowFlightModal', true)
        self.$store.commit('reservation/setCustomPickupTime', { leg: self.leg, value: false })
        self.$store.commit('serviceSelection/hideDateTimePicker')
        if (self.mtech.enabled) {
          self.$store.commit('reservation/setMtechLegData', {
            leg: self.leg,
            fields: { pickupDate: '' }
          })
        }
        if (CONFIG.Env == 'production' && window.gtag) { // eslint-disable-line
          gtag('event', `Flight Date`, { // eslint-disable-line
            value: selectedDate
          })
        }
      } else {
        self.$store.commit('reservation/setPickupDate', { leg: self.leg, value: selectedDate })
        self.$store.commit('reservation/setCustomPickupTime', { leg: self.leg, value: !applySuggested })
        self.$store.commit('serviceSelection/setForPickupDate', false)
        if (self.mtech.enabled) {
          self.$store.commit('reservation/setMtechLegData', {
            leg: self.leg,
            fields: { pickupDate: moment.tz(selectedDate, 'MM/DD/YYYY hh:mmA', rsvpLeg.timezone).format('MM/DD/YYYY hh:mmA') }
          })
          self.$store.commit('serviceSelection/hideDateTimePicker')
          if (!self.isAirportPickup && !self.isAirportDropoff) {
            setTimeout(function () {
              self.getQuote()
            }, 20)
          }
        } else {
          setTimeout(function () {
            self.getQuote()
          }, 20)
        }
        if (CONFIG.Env == 'production' && window.gtag) { // eslint-disable-line
          gtag('event', `Pickup Date`, { // eslint-disable-line
            value: selectedDate
          })
        }
      }
    },
    setSuggestedTime () {
      let date = moment(this.dateTimePickerData.suggestedTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      this.pickupDate = date.format('MM/DD/YYYY')
      let hourFormat = this.isMilitaryTime ? 'HH' : 'hh'
      this.pickupTime = {
        hour: date.format(hourFormat),
        minute: date.format('mm'),
        ampm: date.format('A')
      }
      this.setPickupDate(true)
    },
    setASAP () {
      let self = this
      self.$store.commit('reservation/setIsAsap', { leg: self.leg, value: true })
      // self.$store.commit('reservation/setPassenger', {leg: 'leg1', value: 1})
      // self.$store.commit('reservation/setLuggage', {leg: 'leg1', value: 1})
      self.$store.commit('setTipAmount', 0)
      self.$store.commit('reservation/removeAllExtraStop', 'leg1')
      self.$store.commit('reservation/setAirline', {
        leg: 'leg1',
        airline: '',
        airlineCode: ''
      })
      self.$store.commit('reservation/setFlightNo', { leg: 'leg1', value: '' })
      setTimeout(function () {
        self.getQuote()
      }, 20)
      if (CONFIG.Env == 'production' && window.gtag) { // eslint-disable-line
        gtag('event', `Pickup Date`, { // eslint-disable-line
          value: 'ASAP'
        })
      }
    },
    getQuote () {
      let self = this
      let rsvpData = this.$store.state.reservation[this.leg]
      let pickupDate = rsvpData.pickupDate || rsvpData.flightDate
      pickupDate = pickupDate || moment().format('MM/DD/YYYY')
      pickupDate = moment(pickupDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
      let quoteData = {
        brandId: this.$store.state.brandId,
        date: pickupDate,
        leg: this.leg,
        pickup: {
          lat: rsvpData.pickup.lat,
          lng: rsvpData.pickup.lng
        },
        dropoff: {
          lat: rsvpData.dropoff.lat,
          lng: rsvpData.dropoff.lng
        },
        asap: this.leg === 'leg2' ? false : this._isAsap
      }

      self.$store.commit('serviceSelection/hideDateTimePicker')
      self.$store.commit('reservation/setServiceLoading', true)
      quoteData = {
        brandId: self.$store.state.brandId,
        leg: self.leg,
        pickupDate: pickupDate,
        pickup: {
          lat: rsvpData.pickup.lat,
          lng: rsvpData.pickup.lng
        },
        dropoff: {
          lat: rsvpData.dropoff.lat,
          lng: rsvpData.dropoff.lng
        },
        order: 'priority',
        asap: this._isAsap
      }
      quoteData.pickup = rsvpData.pickup
      quoteData.dropoff = rsvpData.dropoff
      self.extraStop[self.leg].forEach((stop, index) => {
        if (!quoteData.extraStops) {
          quoteData.extraStops = []
        }
        quoteData.extraStops.push({
          lat: stop.location.lat,
          lng: stop.location.lng
        })
      })
      ApiQuote.getQuote2(self, quoteData, (res) => {
        self.$store.commit('reservation/setServiceLoading', false)

        self.$store.commit('reservation/resetServiceEta')
        let serviceExist = false
        let serviceExistForLeg2 = false
        let leg1 = this.$store.state.reservation.leg1
        for (let service in res.services) {
          let serviceData = res.services[service]
          if (parseInt(rsvpData.selectedService.substr(1)) === serviceData.serviceType.id && !self.mtech.enabled && !serviceData.unavailableTime) {
            serviceExist = true
          }
          if (this.leg === 'leg2' && leg1.selectedService && parseInt(leg1.selectedService.substr(1)) === serviceData.serviceType.id && !serviceData.unavailableTime) {
            serviceExistForLeg2 = true
          }
        }
        if (res.mtech) {
          res.mtech.services.forEach(service => {
            if (service.product.code === rsvpData.selectedService) {
              serviceExist = true
            }
          })
        }
        if (res.lyft) {
          res.lyft.forEach(lyft => {
            if (rsvpData.selectedService === `a${lyft.ride_type}`) serviceExist = true
          })
        }
        if (!serviceExist) {
          self.$store.commit('reservation/setSelectedService', {
            leg: self.leg,
            value: ''
          })
        }
        if (serviceExistForLeg2) {
          self.$store.commit('reservation/setSelectedService', {
            leg: 'leg2',
            value: leg1.selectedService
          })
          self.$store.commit('setCurrentIndex', 0)
          self.$store.commit('disablePreviousSteps', 3)
        }

        if (self.mtech.enabled && leg1.selectedService) {
          self.getQuoteMtechService()
        }
      })
    },
    changeTime () {
      this.timeBufferError = ''
      if (this.defaultTimeout) { clearInterval(this.defaultTimeout) }
    },
    buildServiceData (data) {
      let oneway = []
      let roundtrip = []
      for (let i = 0; i < data.maxPassengers; i++) {
        data.oneway[i].price = parseFloat(data.oneway[i].price)
        data.oneway[i].original = parseFloat(data.oneway[i].original)
        data.roundtrip[i].price = parseFloat(data.roundtrip[i].price)
        data.roundtrip[i].original = parseFloat(data.roundtrip[i].original)
        oneway.push(data.oneway[i])
        roundtrip.push(data.roundtrip[i])
      }

      return {
        id: data.id,
        code: data.code,
        brandedName: data.brandedName,
        maxLuggage: data.maxLuggage,
        maxPassengers: data.maxPassengers,
        curbside: data.curbside,
        meetAndGreet: data.meetAndGreet,
        pickupFee: data.pickupFee,
        prices: oneway,
        roundtrip: roundtrip,
        status: data.status,
        airportFee: data.airportFee
      }
    },
    getAirlineList () {
      let self = this

      let pickup = self.$store.state.reservation[self.leg].pickup
      if (typeof pickup.geofenceType === 'undefined' || pickup.geofenceType !== 'airport') { return }

      if (self.airlineLoading || self.$store.state.reservation.airlineGID === pickup.geofenceId) { return }
      self.airlineLoading = true

      self.$sdk.get(self, '/geofences/' + pickup.geofenceId + '/airlines', {}, res => {
        self.airlineLoading = false
        if (!res.error) {
          let airlines = []
          res.list.forEach(function (data) {
            airlines.push({
              code: data.code,
              name: data.name,
              label: '(' + data.code + ') ' + data.name
            })
          })
          self.$store.commit('reservation/setAirlineList', {
            id: pickup.geofenceId,
            list: airlines
          })
        }
      }, '/1.1')
    },
    updatePickupType () {
      let user = this.$store.state.user
      let notInternational = true
      if (user.phone.number) {
        let userPhone = '+' + user.phone.code + user.phone.number
        notInternational = isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
      }
      ApiPickupType.update(this, {isUS: notInternational}, function () {})
    },
    adjustHour (direction) {
      let hourFormat = this.$settings.get('MilitaryTimeWidget') && this.$settings.get('MilitaryTimeWidget') === '1' ? 'HH' : 'hh'
      if (direction === 'up') {
        this.pickupTime.hour = moment(this.pickupTime.hour, 'hh').add(1, 'hour').format(hourFormat)
      } else {
        this.pickupTime.hour = moment(this.pickupTime.hour, 'hh').subtract(1, 'hour').format(hourFormat)
      }
    },
    adjustMinute (direction) {
      if (direction === 'up') {
        this.pickupTime.minute = moment(this.pickupTime.minute, 'mm').add(5, 'minutes').format('mm')
      } else {
        this.pickupTime.minute = moment(this.pickupTime.minute, 'mm').subtract(5, 'minutes').format('mm')
      }
    },
    adjustAmPm (direction) {
      this.pickupTime.ampm = this.pickupTime.ampm === 'AM' ? 'PM' : 'AM'
    },
    applyDefault () {
      let rsvp = this.$store.state.reservation
      let date = ''
      if (this.charter.startDate && this.charter.datePicker === 'startDate') {
        date = this.charter.startDate
      }
      if (this.charter.endDate && this.charter.datePicker === 'endDate') {
        date = this.charter.endDate
      }
      if (rsvp[this.leg].flightDate && this.charter.datePicker === 'flightDate') {
        date = rsvp[this.leg].flightDate
      }
      if (date) {
        let momentDate = moment(date, 'MM/DD/YYYY hh:mmA')
        let hourFormat = this.isMilitaryTime ? 'HH' : 'hh'
        this.pickupDate = momentDate.format('MM/DD/YYYY')
        this.pickupTime = {
          hour: momentDate.format(hourFormat),
          minute: momentDate.format('mm'),
          ampm: momentDate.format('A')
        }
      }
    },
    getQuoteMtechService () {
      let self = this
      let rsvpData = this.$store.state.reservation[this.leg]

      let pickupDate = rsvpData.pickupDate
      if (rsvpData.flightDate && (rsvpData.isAirportDropoff || rsvpData.isAirportPickup)) {
        pickupDate = rsvpData.flightDate
      }
      pickupDate = pickupDate || moment().format('MM/DD/YYYY hh:mmA')
      pickupDate = moment(pickupDate, 'MM/DD/YYYY hh:mmA')
      let quoteData = {
        asap: false,
        brandId: self.$store.state.brandId,
        leg: 'leg1',
        pickupDate: pickupDate.format('YYYY-MM-DD'),
        pickupTime: pickupDate.format('HH:mm:ss'),
        pickup: rsvpData.pickup,
        dropoff: rsvpData.dropoff,
        order: 'priority',
        passengers: rsvpData.passenger,
        mtechServiceType: rsvpData.selectedService
      }
      quoteData.pickup.text = quoteData.pickup.title
      quoteData.dropoff.text = quoteData.dropoff.title
      if (rsvpData.flightDate) {
        quoteData.pickupTimestamp = moment.tz(rsvpData.flightDate, 'MM/DD/YYYY hh:mmA', rsvpData.timezone).format('X')
      } else {
        quoteData.pickupTimestamp = moment.tz(`${quoteData.pickupDate} ${quoteData.pickupTime}`, 'YYYY-MM-DD HH:mm', rsvpData.timezone).format('X')
      }

      self.$store.commit('reservation/setServiceLoading', true)
      let timeNow = moment()
      self.$sdk.post(self, '/quotation', quoteData, res => {
        self.sendQuoteTime(timeNow, moment(), res.quoteId, quoteData)
        self.$store.commit('reservation/setServiceLoading', false)
        if (!res.error) {
          self.$store.commit('reservation/setQuoteId', res.quoteId)
          if (res.mtech.services.length) {
            let mtech = res.mtech
            let mtechStore = self.$store.state.reservation.mtech
            let service = res.mtech.services[0]
            let price = service.price

            let hasDiscount = false
            let discountVal = 0
            let totalBeforeDc = 0
            let baseFare = price.amount
            service.price.breakdown.forEach(x => {
              if (x.description === 'Base rate') {
                baseFare = x.amount
              }
              if (x.description === 'Discount') {
                hasDiscount = true
                discountVal = x.amount
              }
              if (x.amount > 0) {
                totalBeforeDc += x.amount
              }
            })

            let addMarkup = 0
            if (mtech.markup.value) {
              addMarkup = mtechStore.markup.value
              if (mtech.markup.type === '%') {
                addMarkup = baseFare * (mtech.markup.value / 100)
              }
              addMarkup = parseFloat(addMarkup.toFixed(2))
            }

            self.$store.commit('reservation/setMtechNewPricing', {
              code: rsvpData.selectedService,
              val: {
                baseFare: baseFare,
                amount: price.amount,
                addMarkup: addMarkup,
                breakdown: price.breakdown,
                hasDiscount: hasDiscount,
                discountVal: Math.abs(discountVal),
                totalBeforeDc: totalBeforeDc
              }
            })
          }
          self.$nextTick().then(() => {
            self.$forceUpdate()
          })
        }
      }, '2.0')
    },
    sendQuoteTime (start, end, quoteId, param) {
      let self = this
      let store = self.$store.state
      let duration = end.diff(start, 'milliseconds') / 1000
      self.$sdk.opt('/quotation/time', {
        token: store.user.token,
        brandId: store.brandId,
        quotationId: quoteId,
        responseTime: duration,
        deviceType: 'ww',
        data: JSON.stringify(param)
      }, res => {
        if (res.error) console.log('ERROR quotation time')
      })
    }
  },
  watch: {
    show: function (value) {
      this.$forceUpdate()
      document.body.classList.remove('widget-no-scroll')
      if (value) {
        document.body.classList.add('widget-no-scroll')
        let self = this
        let rsvp = self.$store.state.reservation
        if (this.defaultTimeout) { clearInterval(this.defaultTimeout) }
        if (this.charter.enabled) {
          this.applyDefault()
          return
        }

        if (rsvp[self.leg].pickupDate === '' && !self.isAirportPickup && !self.isAirportDropoff) {
          self.$nextTick(function () {
            let timebuffer = rsvp[self.leg].isAirportPickup || rsvp[self.leg].isAirportDropoff ? 0 : rsvp.webTimeBuffer
            self.pickupDate = moment.tz(rsvp.leg1.timezone)
              .add(timebuffer, 'minutes').format('MM/DD/YYYY')
            self.pickupTime = {
              hour: moment.tz(rsvp.leg1.timezone).add(timebuffer, 'minutes').format(self.hourFormat),
              minute: moment.tz(rsvp.leg1.timezone)
                .add(timebuffer, 'minutes')
                .add(5 - (moment.tz(rsvp.leg1.timezone).add(timebuffer, 'minutes').minute() % 5), 'minutes').format('mm'),
              ampm: moment.tz(rsvp.leg1.timezone).add(timebuffer, 'minutes').format('A')
            }
          })
        } else if (!rsvp[self.leg].flightDate && (self.isAirportPickup || self.isAirportDropoff)) {
          let tz = this.$store.state.reservation.leg1.timezone
          let timebuffer = rsvp.webTimeBuffer
          let timePlusBuffer = moment.tz(tz).add(timebuffer, 'minutes')
          this.pickupDate = timePlusBuffer.format('MM/DD/YYYY')
          this.pickupTime = {
            hour: timePlusBuffer.format('hh'),
            minute: timePlusBuffer.add(5 - (moment.tz(tz).add(timebuffer, 'minutes').minute() % 5), 'minutes').format('mm'),
            ampm: timePlusBuffer.format('A')
          }
        } else if (rsvp[self.leg].flightDate && (self.isAirportPickup || self.isAirportDropoff) &&
          !self.dateTimePickerData
        ) {
          let date = moment(rsvp[self.leg].flightDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
          self.pickupDate = date.format('MM/DD/YYYY')
          let hourFormat = self.isMilitaryTime ? 'HH' : 'hh'
          self.pickupTime = {
            hour: date.format(hourFormat),
            minute: date.format('mm'),
            ampm: date.format('A')
          }
        }
      }
    },
    _pickupDate: function (value) {
      let date = moment()
      if (this.isAirportPickup || this.isAirportDropoff) return
      if (value) {
        date = moment(value, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      }
      this.pickupTime = {
        hour: date.format(this.hourFormat),
        minute: date.format('mm'),
        ampm: date.format('A')
      }
      this.timeBufferError = ''
    },
    _isAsap: function (value) {
      this.isFutureActive = !value
      this.timeBufferError = ''
    },
    _forPickupDate: function (value) {
      let rsvp = this.$store.state.reservation
      let date = moment(rsvp[this.leg].flightDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      if (value) {
        date = moment(this.$store.state.serviceSelection.dateTimePicker.customPickupDateDefault, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      }
      this.pickupDate = date.format('MM/DD/YYYY')
      let hourFormat = this.isMilitaryTime ? 'HH' : 'hh'
      this.pickupTime = {
        hour: date.format(hourFormat),
        minute: date.format('mm'),
        ampm: date.format('A')
      }
    }
  },
  mounted () {
    let self = this
    let rsvp = self.$store.state.reservation
    let hourFormat = this.isMilitaryTime ? 'HH' : 'hh'
    if (self.charter.enabled) { return }
    if (rsvp[this.leg].pickupDate ||
      (rsvp[this.leg].flightDate && (rsvp[this.leg].isAirportPickup || rsvp[this.leg].isAirportDropoff))
    ) {
      let selectedDate = ''
      if ((rsvp[this.leg].flightDate && (rsvp[this.leg].isAirportPickup || rsvp[this.leg].isAirportDropoff)) && !self.dateTimePickerData.forPickupDate) {
        selectedDate = moment(rsvp[this.leg].flightDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      } else {
        selectedDate = moment(rsvp[this.leg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      }
      this.pickupDate = selectedDate.format('MM/DD/YYYY')
      this.pickupTime = {
        hour: selectedDate.format(hourFormat),
        minute: selectedDate.format('mm'),
        ampm: selectedDate.format('A')
      }
    }
    if (rsvp[this.leg].isAsap) { this.isFutureActive = false }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}

.datetimepicker{
  background-color: #fff;
  max-width: 600px;
  margin: 0 auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
}

.datetimepicker-tab{
  margin-bottom: 10px;
  display: flex;

  span{
    background: #f6f6f6;
    border-bottom: 1px solid #ddd;
    padding: 10px;
    text-align: center;
    width: 50%;
    display: inline-block;
    cursor: pointer;
    color: #555;

    i{ margin-right: 5px; }
    &.active{
      background: #fff;
      border: none;
    }
    &:not(.active){
      box-shadow: 0 -1px 1px rgba(0,0,0, .05) inset;
      color: #aaa;
    }
    &:first-child:not(.active){ border-right: 1px solid #ddd }
    &:last-child:not(.active){ border-left: 1px solid #ddd }
  }
}
.datetimepicker-box {
  padding: 20px;

  .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 5px;
  }

  .separator {
    &::after {
      content: "or";
    }
  }
}

.estimated-dropoff{
  color: #777;
  font-size: 14px;
  font-style: italic;
}

.pickuptime{
  text-align: center;
  display: block;
  padding-left: 10px;

  .title { margin-bottom: 0; }
  .select{
    position: relative;
    display: inline-block;
    width: 50px;
    text-align: center;
    margin: 25px 10px 0;

    .label{
      padding: 10px 10px 5px;
      font-size: 22px;
      line-height: 22px;

      .icon{ float: right; }
    }
    .fas{
      left: 50%;
      padding: 0 5px;
      color: #495057;
      cursor: pointer;
      position: absolute;
      transform: translateX(-50%);
      transition: all .2s ease-out;

      &.increase{ top: -30px; }
      &.decrease{ top: calc(100% + 3px); }
      &.highlight{ background: #d2f0ff; }
    }

    select{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    &.border{
      border-left: 0;
    }
  }

  .pickuptime-rule{
    font-size: 13px;
    display: block;
    color: #aaa;
  }

  .pickuptime-rule{
    font-size: 13px;
    display: block;
    color: #aaa;
  }
  .pickuptime-ui{ margin-top: 10px; }

  .buttons{
    margin-top: 50px;
    padding-left: 7px;
  }
}

.date-error-msg{
  font-size: 14px;
  padding: 5px;
  display: block;
  color: #ef4b4b;
  background: #fde5e5;
  border-radius: 4px;
  border: 1px solid #ef4b4b;
  line-height: 1.4;
}

.cancel-pickup{
  text-align: center;
  span{
    padding: 2px 5px;
    cursor: pointer;
    color:#aaa;

    &:hover{
      text-decoration:underline;
      color:#777;
    }
  }
}

@media only screen and (max-width: 639px) {
  .datetimepicker-box .pickuptime{
    margin-top: 20px;
    padding-left: 0;

    .buttons{ padding-left: 0; }
  }
}
</style>



// WEBPACK FOOTER //
// DateTimePicker.vue?62782371